/**
 * @param {String} type
 * @param {Object} database
 * @param {Object} scenario
 * @param {String} uuid
 */
export default function remove(type, scenario, uuid) {
  if (Object.hasOwn(scenario.entities[type], uuid)) {
    delete scenario.entities[type][uuid];
  }
}
